import { memo } from "react";
import { useContent } from "../../../../../../../contexts/contentContext/contentContext";
import getCreditCardImage from "./helpers/getCreditCardImage";
import Image from "../../../../../../Elements/Image/Image";
import useCreditCard from "../../../../hooks/useCreditCard";
import { PaymentTypeE } from "../../../../models/enums";

import styles from "./styles.module.scss";

interface CreditCardDetailsI {
  paymentType: PaymentTypeE;
  creditCardId?: number;
}

/**
 * Renders the credit card details component.
 *
 * @component
 * @param {CreditCardDetailsI} props - The component props.
 * @returns {JSX.Element} The rendered component.
 */

const CreditCardDetails = memo((props: CreditCardDetailsI) => {
  const { paymentType, creditCardId } = props;
  const { getCreditCardById } = useCreditCard();
  const { getTextByKey } = useContent();

  const creditCard = creditCardId ? getCreditCardById(creditCardId) : undefined;

  const imageData = getCreditCardImage(
    creditCard?.CreditCardBrand,
    paymentType
  );

  return (
    <div className={styles.creditCardLine}>
      <span
        className={
          paymentType === PaymentTypeE.PAYPAL
            ? styles.paypalImage
            : styles.image
        }
      >
        {imageData.name ? (
          <Image {...imageData} alt={creditCard?.CreditCardBrand} title={creditCard?.CreditCardBrand}/>
        ) : null}
      </span>
      {paymentType !== PaymentTypeE.PAYPAL &&
        paymentType !== PaymentTypeE.NEW_CREDIT_CARD && (
          <span style={{
            direction: 'ltr',
          }}>{"**** **** **** " + creditCard?.CreditCardNumber}</span>
        )}
      {paymentType === PaymentTypeE.NEW_CREDIT_CARD && (
        <div className={styles.newCreditCard}>
          {getTextByKey("add-new-credit-card")}
        </div>
      )}
    </div>
  );
});

export default CreditCardDetails;
